module.exports = __webpack_public_path__ + "assets/HKNova-SemiBold.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-SemiBold.svg
// module id = 131
// module chunks = 0